import { render, staticRenderFns } from "./QaMonitor.vue?vue&type=template&id=70e036f8&scoped=true"
import script from "./QaMonitor.vue?vue&type=script&lang=ts"
export * from "./QaMonitor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e036f8",
  null
  
)

export default component.exports